export function showFullScreenOverlay(withLoader: boolean = false) {
    const fullScreenOverlay = $('.full-screen-overlay');
    fullScreenOverlay.show();
    if (withLoader) {
        $('.__loader', fullScreenOverlay).show();
    }
}

export function hideFullScreenOverlay() {
    $('.full-screen-overlay, .full-screen-overlay .__loader').hide();
}
